import React from "react";
import { Link } from "react-router-dom";

function Claim() {
  const data = [
    {
      id: 1,
      icon: "flaticon-insurance-4",
      step: "STEP 01",
      name: "Call the Police if",
      subname: "Necessary",
    },
    {
      id: 2,
      icon: "flaticon-portfolio",
      step: "STEP 02",
      name: "Everything and",
      subname: "Exchange Information",
    },
    {
      id: 3,
      icon: "flaticon-workgroup",
      step: "STEP 03",
      name: "Contact Insurance",
      subname: "Company",
    },
    {
      id: 4,
      icon: "flaticon-agreement",
      step: "STEP 04",
      name: "Filing Your Insurance",
      subname: "Claim",
    },
  ];

 
  return (
    <>
      <section className="steps-one steps-one--home-3">
        <div
          className="steps-one__bg"
          style={{
            backgroundImage: "url(assets/images/shapes/steps-bg-1-1.png)",
          }}
        />

        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">How to Claim</p>

            <h3 className="sec-title__title">
              Here are some important steps to <br />
              take insurance claim.
            </h3>
          </div>

          <ul className="list-unstyled steps-one__list">
            {data.map((item) => (
              <li key={item.id}>
                <div className="steps-one__list__icon">
                  <i className={item.icon} />
                  <div className="steps-one__list__caption">{item.step}</div>
                </div>

                <h3 className="steps-one__list__title">
                  <a href="#">
                    {item.name}
                    <br /> {item.subname}
                  </a>
                </h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="contact-two contact-two--service contact-two--home-3">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-6">
              <div className="contact-two__images">
                <img src="assets/images/resources/contact-2-3.jpg" />
              </div>
            </div>

            <div className="col-md-12 col-lg-6 d-flex">
              <div className="my-auto">
                <form
                  action="assets/inc/sendemail.php"
                  className="contact-two__form contact-form-validated"
                >
                  <div className="sec-title text-start">
                    <p className="sec-title__tagline">Get free estimate</p>

                    <h3 className="sec-title__title">
                      Get an insurance quote to get started!
                    </h3>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <i className="far fa-user" />
                          <input
                            type="text"
                            placeholder="Full Name"
                            name="name"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <i className="far fa-phone-plus" />
                          <input
                            type="text"
                            placeholder="Phone No"
                            name="phone"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <i className="far fa-envelope-open" />
                          <input
                            type="text"
                            placeholder="Email Address"
                            name="email"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <select name="insurance" className="niceselect">
                            <option value="Type Of Insurance">
                              Type Of Insurance
                            </option>
                            <option value="Life Insurance">
                              Life Insurance
                            </option>
                            <option value="Business Insurance">
                              Business Insurance
                            </option>
                            <option value="Health Insurance">
                              Health Insurance
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <select name="gender" className="niceselect">
                            <option value="Gender">Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-two__input">
                        <div className="contact-two__input__label">
                          <i className="far fa-calendar-alt" />
                          <input
                            type="text"
                            placeholder="Birth Date"
                            name="birthday"
                            className="datepicker"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="contact-two__input">
                        <div className="contact-two__input__title">
                          Limit Of Balance
                        </div>

                        <div className="contact-two__progress-range">
                         
                          <div className="contact-two__balance-box">
                            <p className="contact-two__balance" id="show">
                              $0 <span />
                            </p>
                          </div>
                          <input
                            type="hidden"
                            className="contact-two__balance__input"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="contact-two__input">
                        <button
                          type="submit"
                          className="thm-btn thm-btn--three contact-two__btn"
                        >
                          <span>
                            Get a Quote
                            <i className="far fa-arrow-right" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Claim;
